import { render, staticRenderFns } from "./featured.vue?vue&type=template&id=a8129b44&scoped=true"
import script from "./featured.vue?vue&type=script&lang=js"
export * from "./featured.vue?vue&type=script&lang=js"
import style0 from "./featured.vue?vue&type=style&index=0&id=a8129b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8129b44",
  null
  
)

export default component.exports